import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_MENU_LIST: string = '[ecommerce settings] Load Ecommerce Menu List';
export const LOAD_ECOMMERCE_MENU_LIST_SUCCESS: string = '[ecommerce settings] Load Ecommerce Menu List Success';
export const LOAD_ECOMMERCE_MENU_LIST_FAIL: string = '[ecommerce settings] Load Ecommerce Menu List Fail';

export class LoadEcommerceMenuList implements Action {
  readonly type: string = LOAD_ECOMMERCE_MENU_LIST;

  constructor(public payload: { websiteId: string }) {
  }
}

export class LoadEcommerceMenuListSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_MENU_LIST_SUCCESS;

  constructor(public payload: {
    menus: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: string
  }) {
  }

}

export class LoadEcommerceMenuListFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_MENU_LIST_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceNavigationAction = LoadEcommerceMenuList | LoadEcommerceMenuListSuccess | LoadEcommerceMenuListFail;
